const map = {
	"./2010/Photos/Index.vue": 78773,
	"./2011/Photos/Index.vue": 38688,
	"./2012/Photos/Index.vue": 7599,
	"./2013/Photos/Index.vue": 12322,
	"./2014/Photos/Index.vue": 13505,
	"./2015/Photos/Index.vue": 23180,
	"./2016/Photos/Index.vue": 99835,
	"./2017/Photos/Index.vue": 45038,
	"./2018/Photos/Index.vue": 91757,
	"./2019/Photos/Index.vue": 49080,
	"./2021/Photos/Index.vue": 70225,
	"./2022/Photos/Index.vue": 42686,
	"./2023/Photos/Index.vue": 65099,
	"./2024/Photos/Index.vue": 22512,
	"./2025/Photos/Index.vue": 99141,
	"./2026/Photos/Index.vue": 59794
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20900;